import {React, useState} from 'react'
import './DropdownComponent.css'

export function DropdownComponent(props) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="dropdown">
            {/* <a href="#" className="icon-button" onClick={() => setIsOpen(!isOpen)}>
                {props.icon}
            </a> */}
            <div className='dropdown-toggle' onClick={() => setIsOpen(!isOpen)}>
                <span className="icon-left">{props.leftIcon}</span>
                Categories
                <span className="icon-right">{props.rightIcon}</span>
            </div>


            {isOpen && props.children}
        </div>
    )
}

export function DropdownMenu({setActive}) {
    
    function DropdownItem(props) {
        return (
            <a href="#" className='menu-item' onClick={() => props.goToMenu && setActive(props.goToMenu)}>
                <p className='hover-underline-animation'>{props.children}</p>
                <span className='icon-right'> {props.rightIcon}</span>
            </a>
        )
    }

    return (
        <div className="dropdown">
            <DropdownItem goToMenu="ENCLOSURES" setActive={setActive}>ENCLOSURES</DropdownItem>
            <DropdownItem goToMenu="VARIABLE FREQUENCY DRIVES" setActive={setActive}>VARIABLE FREQUENCY DRIVES</DropdownItem>
            <DropdownItem goToMenu="PLC CONTROL" setActive={setActive}>PLC CONTROL</DropdownItem>
            <DropdownItem goToMenu="POWER & CONTROL" setActive={setActive}>POWER AND CONTROL</DropdownItem>
        </div>
    )
}

// export default DropdownComponent;